import React, {useEffect, useState} from 'react'
import "./VideoIframe.scss";

type VideoIframeProps = {
    embed: string;
}

export default function VideoIframe({embed}: VideoIframeProps) {
    const [source, setSource] = useState('');

    useEffect(() => {
        setSource(embed);
    }, [embed]);

    return (
        <div className="modal-iframe-wrapper">
            {source && <iframe title={embed} id="modal-iframe" width="100%" height="100%" src={source} frameBorder="0"
                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                               allowFullScreen>&nbsp;</iframe>}
        </div>
    )
}
